<template>
<div @click.self="close" class="search-overlay print-hide" :class="{'active':searchOpen, 'transitioning': transitioning}">
	<section @click="focusInput">
		<input v-model="query" @keydown.enter="search" @keydown.escape="close" ref="searchInput" placeholder="Press 'Return' to search">
	</section>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

	name: "SearchOverlay",

	data(){
		return {
			transitioning: false,
			query:"",
		}
	},

	methods: {
		search(){
			this.$router.push({name:'search',params:{query:this.query}});
			this.$store.dispatch("toggleSearchOpen");
		},

		close(){
			if(this.searchOpen){
				this.$store.dispatch("toggleSearchOpen");
			}

		},
		focusInput(){
			this.$refs.searchInput.focus();
		},
	},

	watch: {

		searchOpen(value){
			if(!this.transitioning){
				this.transitioning = true;
				setTimeout(()=>{
					this.transitioning = false;
				},750)
			}

			if(value){
				setTimeout(()=>{
					this.query = "";
					this.$refs.searchInput.focus();
				},0);
			}
		},
	},

	computed: {
		...mapGetters(["searchOpen"])
	}

}

</script>
